export default __webpack_public_path__ + "static/media/icon-eye-close.a9c2a7d1.webp";